import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';
import { type Breakpoint } from '@mui/system';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  variants: [
    {
      props: { maxWidth: 'sm' },
      style: {
        '& .MuiPaper-root': {
          maxWidth: '346px',
          '& .MuiDialogTitle-root': { fontSize: '20px', gap: '10px' },
        },
      },
    },
    {
      props: { maxWidth: 'sm-md' as Breakpoint },
      style: {
        '& .MuiPaper-root': {
          maxWidth: '352px',
          '& .MuiDialogTitle-root': { fontSize: '20px', gap: '10px' },
        },
      },
    },
    {
      props: { maxWidth: 'md' },
      style: {
        '& .MuiPaper-root': {
          maxWidth: '445px',
        },
      },
    },
    {
      props: { maxWidth: 'md-lg' as Breakpoint },
      style: {
        '& .MuiPaper-root': {
          maxWidth: '498px',
        },
      },
    },
    {
      props: { maxWidth: 'lg' },
      style: {
        '& .MuiPaper-root': {
          maxWidth: '550px',
        },
      },
    },
  ],
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: '10px',
      minWidth: '295px',
      padding: '24px 16px',
      margin: '12px',
      gap: '20px',
      width: 'calc(100% - 24px)',
      [theme.breakpoints.down('sm')]: {
        minWidth: '296px',
      },
      '& .MuiDialogTitle-root': {
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '29px',
        padding: 0,
        '&.DialogTitle-small': {
          fontSize: '20px',
          lineHeight: 1.2,
        },
        '&.DialogTitle-large': {
          fontSize: '26px',
          lineHeight: 1.2,
        },
      },
      '& .MuiDialogContent-root': {
        display: 'flex',
        padding: 0,
      },
    }),
  },
};
